var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnel02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25722 3.77791C1.75299 3.21437 1.50088 2.93259 1.49137 2.69312C1.48311 2.48509 1.57251 2.28515 1.73305 2.15259C1.91785 2 2.29595 2 3.05215 2H12.9474C13.7036 2 14.0817 2 14.2665 2.15259C14.4271 2.28515 14.5165 2.48509 14.5082 2.69312C14.4987 2.93259 14.2466 3.21437 13.7424 3.77791L9.9382 8.02962C9.83769 8.14196 9.78743 8.19813 9.7516 8.26205C9.71981 8.31875 9.69649 8.37978 9.68238 8.44323C9.66646 8.51476 9.66646 8.59013 9.66646 8.74087V12.3056C9.66646 12.436 9.66646 12.5011 9.64543 12.5575C9.62685 12.6073 9.59663 12.6519 9.55729 12.6877C9.51277 12.7281 9.45225 12.7524 9.3312 12.8008L7.06453 13.7074C6.8195 13.8054 6.69699 13.8545 6.59864 13.834C6.51263 13.8161 6.43716 13.765 6.38862 13.6918C6.33312 13.6081 6.33312 13.4762 6.33312 13.2122V8.74087C6.33312 8.59013 6.33312 8.51476 6.3172 8.44323C6.30309 8.37978 6.27977 8.31875 6.24798 8.26205C6.21215 8.19813 6.16189 8.14196 6.06138 8.02962L2.25722 3.77791Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel02);
export default __webpack_public_path__ + "static/media/filter-funnel-02.24c9d8f1fb101adf007c863f7e33c1aa.svg";
export { ForwardRef as ReactComponent };